
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";
import { FeedbackManuscriptMode } from "@/lib/models/assist";

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    CatIcon,
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    onClickWriterTypeIndicator() {
      const baseUrl = process.env.VUE_APP_NOLA_WEB;
      const writerTypeUrl = `${baseUrl}/writer-type-indicator/`;
      window.open(writerTypeUrl, "_blank");
    },
    async handleSkipAndChangeMode() {
      try {
        await this.$store.dispatch("assistantCatModule/createAssistantCatMasterOnSkip");
        await this.$store.dispatch("assistantCatModule/updateAssistantCatMaster", {
          feedbackManuscriptMode: FeedbackManuscriptMode.DRY,
        });
        this.$emit("done");
        this.$emit("close");
      } catch (error) {
        console.error("Failed to skip and change feedback mode:", error);
        this.$notify({
          title: this.$t("myPage.writerTypeIndicatorSkipDialog.errorMessage") as string,
          type: "error",
        });
      }
    },
  },
});

interface Data {}

interface Methods {
  handleClose: () => void;
  onClickWriterTypeIndicator: () => void;
  handleSkipAndChangeMode: () => Promise<void>;
}
